import axios from "axios";

import DateUtil from "../utils/DateUtil";

//import GmxGlobal from "../global";
import GmxRequest from './unit/GmxRequest.js';
import {EncryptUtil} from '@/js/utils/crypto/EncryptUtil';
//import { getCookie } from "../utils/CookieUtil";

/**
 * 모든 axios 요청에 대한 선언입니다.
 *
 *  - 개발 진행 단계에서는 파일 분할 및 객체 분할 계획 없습니다.
 *  - 추가 필요할 시 간단한 주석 정도만 부탁드립니다.
 *  - 필요 파라미터는 Back-end에서 확인해주시거나 스웨거를 통하여 확인 부탁드립니다.
 *
 * @owner 안형준
 *
 */
const API_CONTEXT_API = "/esupport-api";
const API_CONTEXT_SEARCH_API = "/searchSvc";
const API_ADDR_USER = "common/mtUsrDesc";
const API_ADDR_ORGZ = "/common/mtOrgzDesc";
const API_ADDR_UGRP = "/common/mtAuthGrp";
const API_ADDR_ACCLVL = "/common/mtAccLvl";
const API_ADDR_AUTHJOIN = "/common/mtAuthJoin";
const API_ADDR_TFAUTHJOIN = "/common/tfAuthJoin";
const API_ADDR_CODE = "/common/mtCmmCde";
const API_ADDR_AUTH = "/common/mtAuthList";
const API_ADDR_FILE = "mnt";
const API_ADDR_EZONE = "esupport";
const API_ADDR_MNG = "common";

const getCodeUrl = code => {
    if (code.startsWith("Ct")) {
        return `${API_CONTEXT_API}/${API_ADDR_EZONE}/ct${code.substring(2)}`;
    } else if (code.startsWith("Mt")) {
        return `${API_CONTEXT_API}/${API_ADDR_MNG}/mt${code.substring(2)}`;
    } else if(code === 'MyPage'){
        return `${API_CONTEXT_API}/${API_ADDR_EZONE}/my${code.substring(2)}`;
    }
    return "";
};

export default {
    /**
     * 파일 업로드(작동 잘됨)
     */
    uploadFile: (param, callBack) => {

        axios.post(`${API_CONTEXT_API}/${API_ADDR_FILE}/mtFileList/upload`, param, { headers: { 'Access-Control-Allow-Origin': '*', "Content-Type": 'multipart/form-data' }, timeout: 60000  })
            .then(function (response) {
                callBack(response);
            })
            .catch(function (error) {
                callBack(error);
            });
    },

    test: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/brobill/selectTax`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    /**
     * 파일 다운로드(작동 잘됨)
     * vue3는 파일 다운로드 방식이 다르다 함.
     */
    downloadFile: (fileIdx, callBack) => {

        axios({
            url: `${API_CONTEXT_API}/${API_ADDR_FILE}/mtFileList/download`,
            params: { fileIdx: fileIdx },
            method: "GET",
            responseType: "blob", // 바이너리 데이터로 응답 받기 위해 responseType을 'blob'으로 설정
        }).then((response) => {
            // 파일 다운로드를 위한 코드
            const contentDisposition = response.headers["content-disposition"];
            let filename = null;

            if (contentDisposition) {
                const matches = contentDisposition.match(/filename="(.+\..+)"/);
                if (matches && matches.length > 1) {
                    filename = matches[1];
                }
            }

            if (filename == null) {
                throw new Error('강제로 예외를 발생시킵니다.');
            }

            filename = decodeURIComponent(filename);

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename); // 파일 이름과 확장자 지정
            document.body.appendChild(link);
            link.click();

            callBack(response.status);
        }).catch(() => {
            callBack(null);
        });
    },

    /**
     * 파일 목록 조회
     */
    selectFileList: (param, callBack) => {

        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_FILE}/mtFileList/selectMtFileList`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    deleteFileList: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_FILE}/mtFileList/deleteMtFileList`, { param, method: "get" }, res => {
            callBack(res);
        });
    },
    /**
     * 토큰 체크.
     */
    getToken: async () => {
       

        return new Promise((resolve) => {

            axios.post(`${API_CONTEXT_API}/getAccessToken`, {}, {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(res => {
                resolve(res);
            }).catch(error => {
                
                //removeLocalItem('eUserId');
                //removeLocalItem('eUserNm');
                //removeLocalItem('searchVal');
                console.error('Error respons e:', error.response);
                resolve(error);
            });

            // GmxRequest.load(API_CONTEXT_API + '/getAccessToken', { param: {refreshToken : getCookie('refresh_token') }, method: 'get' }, (res) => {
            //     resolve(res);
            // });
        });
    },

    /**
     * 로그인 (보안 개선 버전)
     *
     * @param {*} param
     * @param {*} callBack
     */
    login: async (param, callBack) => {
        try {
            // 1. 서버에서 Public Key만 받기
            const keyResponse = await new Promise((resolve) => {
                GmxRequest.load(API_CONTEXT_API + "/loginKey", { param: {}, method: "get" }, res => {
                    resolve(res);
                });
            });
            
            // 2. Public Key와 Modulus만 추출 (Private Key 제거)
            const { public: publicKey, modulus } = keyResponse.data.result;
            
            if (!publicKey || !modulus) {
                throw new Error('Public Key 또는 Modulus를 받을 수 없습니다.');
            }
            
            // 3. 클라이언트에서 LEA 세션키 생성
            const leaSessionKey = EncryptUtil.generateSecureKey(16); // 16바이트 랜덤 키
            let leaKey = leaSessionKey;
            if (leaKey.length < 16) {
                // 16바이트보다 짧으면 패딩
                leaKey = leaKey.padEnd(16, '0');
            } else if (leaKey.length > 16) {
                // 16바이트보다 길면 자르기
                leaKey = leaKey.substring(0, 16);
            }
            
            console.log('🔑 생성된 LEA 세션키 길이:', leaKey.length);
            console.log('🔑 생성된 LEA 세션키 :', leaKey);
                
        
            // 4. LEA 세션키로 사용자 데이터 암호화
            const encryptedUserId = EncryptUtil.encryptLEA(param.userId, leaKey);
            const encryptedUserPwd = EncryptUtil.encryptLEA(param.userPwd, leaKey);
            
            // 5. RSA로 LEA 세션키 암호화 (서버 전송용)
            const encryptedSessionKey = EncryptUtil.encryptRSA(leaKey, publicKey, modulus);
            
          //  암호화된 userId: UjV/sW7QLd5yB4ioRRTmSw==
//사용할 sessionKey: 3df9527a9e904ee5d7ce339ede9750f6

            // 6. 서버로 전송
            const loginParam = {
                userId: encryptedUserId,
                userPwd: encryptedUserPwd,
                sessionKey: encryptedSessionKey,  // RSA로 암호화된 LEA 키
                modulus: modulus,  // RSA로 암호화된 LEA 키
            };
            
            GmxRequest.load(API_CONTEXT_API + "/login", { param: loginParam, method: "get" }, res => {
                callBack(res);
            });

            
        } catch (error) {
            console.error('로그인 처리 중 오류:', error);
            callBack({
                data: {
                    status: 'error',
                    message: '로그인 처리 중 오류가 발생했습니다.'
                }
            });
        }
    },


    /**
     * 평문 로그인
     *
     * @param {*} param
     * @param {*} callBack
     */
    plainLogin: (param, callBack) => {
        GmxRequest.load(API_CONTEXT_API + "/plainLogin", { param, method: "get" }, res => {
            callBack(res);
        });
    },
    /**
     * 로그인 암호화 키 요청
     *
     * @param {*} param
     * @param {*} callBack
     */
    loginKey: (param, callBack) => {
        GmxRequest.load(API_CONTEXT_API + "/loginKey", { param, method: "get" }, res => {
            callBack(res);
        });
    },


    /**
     * 로그아웃
     *
     * @param {*} param
     * @param {*} callBack
     */
    signLogout: (param, callBack) => {
        GmxRequest.load(API_CONTEXT_API + "/logout", { param, method: "get" }, res => {
            callBack(res);
        });
    },

    /**
     * 계정 등록
     *
     * @param {*} param
     * @param {*} callBack
     */
    requestEmailAuth: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_USER}/requestEmailAuth`, { param, method: "post" }, res => {
            callBack(res);
        });
    },

     /**
     * 패스워드 재설정
     * @param {Object} param - 파라미터 (userId, newPassword, verificationToken)
     * @param {Function} callBack - 콜백 함수
     */
     resetPassword: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_USER}/verifyEmailAuth`, { param, method: "post" }, res => {
            callBack(res);
        });
    },
    /**
     * 계정 등록
     *
     * @param {*} param
     * @param {*} callBack
     */
    addUserInfo: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_USER}/insertMtUsrDesc`, { param, method: "post" }, res => {
            callBack(res);
        });
    },

    /**
     * 계정 수정
     *
     * @param {*} param
     * @param {*} callBack
     */
    updUserInfo: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_USER}/updateMtUsrDesc`, { param, method: "post" }, res => {
            callBack(res);
        });
    },
    /**
     * 계정 수정
     *
     * @param {*} param
     * @param {*} callBack
     */
    updUserInfoNoValid: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_USER}/updateMtUsrDescNoValid`, { param, method: "post" }, res => {
            callBack(res);
        });
    },

    /**
     * 계정 삭제
     *
     * @param {*} param
     * @param {*} callBack
     */
    delUserInfo: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_USER}/select`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    /**
     * 아이디/패스워드 찾기
     * common/mtUsrDesc/selectMtUsrDesc
     * @param {d} param
     * @param {*} callBack
     */
    findUserInfo: async (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_USER}/selectMtUsrDesc`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    /**
     * 사용자 ID 중복 체크
     * @param {*} param
     * @param {*} callBack
     */
    findUserIdChk: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_USER}/findUserIdChk`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    findSyncUserInfo: async (param) => {
        return new Promise((resolve) => {

            GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_USER}/selectSyncMtUsrDesc`, { param, method: "get" }, res => {
                resolve(res);
            });

        });
    },

    /**
     * 부서 정보 조회
     * common/mtUsrDesc/selectMtUsrDesc
     * @param {d} param
     * @param {*} callBack
     */
    selectOrgzList: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_ORGZ}/selectMtOrgzDesc`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    /**
     * 사용자 그룹 정보 조회
     * common/mtUsrDesc/selectMtUsrDesc
     * @param {d} param
     * @param {*} callBack
     */
    selectUgrpList: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_UGRP}/selectMtAuthGrp`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    deleteUgrp: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_UGRP}/deleteMtAuthGrp`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    addUgrp: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_UGRP}/insertMtAuthGrp`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    updUgrp: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_UGRP}/updateMtAuthGrp`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    selectAuthList: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_AUTH}/selectMtAuthList`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    modAuth: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_TFAUTHJOIN}/insert`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    selectAuthJoin: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_AUTHJOIN}/selectMtAuthJoin`, { param, method: "get" }, res => {
            
            callBack(res);
        });
    },

    selectSyncAuthJoin: async (param) => {
        return new Promise((resolve) => {
            
            GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_AUTHJOIN}/selectMtAuthJoin`, { param, method: "get" }, res => {
                resolve(res);
            });

        });
    },

    selectMtCode: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_CODE}/selectMtCmmCde`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    selectMtUsrDesc: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_USER}/selectMtUsrDesc`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    selectMtUsrDescMention: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_USER}/selectMtUsrDescMention`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    selectMtUsrDescTarget: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_USER}/selectMtUsrDescTarget`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    selectMtUsrMngDesc: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_USER}/selectMtUsrMngDesc`, { param, method: "get" }, res => {
            callBack(res);
        });
    },


    /**
     * 업체 등급코드 정보 조회
     * common/mtUsrDesc/selectMtUsrDesc
     * @param {d} param
     * @param {*} callBack
     */
    selectAccLvlList: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/${API_ADDR_ACCLVL}/selectMtAccLvl`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    /**
     * 업체 등급코드 정보 조회
     * common/mtUsrDesc/selectMtUsrDesc
     * @param {d} param
     * @param {*} callBack
     */
    selectMtTarget: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/common/mtTarget/selectMtTargetItem`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    /**
     * 업체 등급코드 정보 조회
     * common/mtUsrDesc/selectMtUsrDesc
     * @param {d} param
     * @param {*} callBack
     */
    insertMtTarget: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/common/mtTarget/insertMtTarget`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    /**
     * 비밀번호 초기화
     *
     * @param {*} param
     * @param {*} callBack
     */
    initPassWord: (param, callBack) => {
        GmxRequest.load(`${process.env.VUE_APP_GmxRequest.load_URL}/${API_ADDR_USER}/stateAll`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    selectCommonList: (code, param, callBack) => {
  
        GmxRequest.load(`${getCodeUrl(code)}/select${code}`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    selectCommonListState: (code, param, callBack) => {

        // 대문자 변환이 필요한 필드들
        ['saleCd', 'projCd', 'contCd', 'ordersContCd'].forEach(field => {
            if (param[field]) {
                param[field] = param[field].toUpperCase();
            }
        });

        GmxRequest.load(`${getCodeUrl(code)}/state${code}`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    selectCommonListStateForm: (code, param, callBack) => {
        GmxRequest.load(`${getCodeUrl(code)}/stateFormCtProj`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    selectCommonInfo: (code, param, callBack) => {
        GmxRequest.load(`${getCodeUrl(code)}/select${code}`, { param, method: "get" }, res => {
 
            callBack(res);
        });
    },

    selectMonitorContYear: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/monitor/selectMonitorContYear`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    selectMonitorSalesYearTable: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/monitor/selectMonitorSalesYearTable`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    selectMonitorSalesTarget: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/monitor/selectMonitorSalesTarget`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    selectMonitorCsGraphTable: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/monitor/selectMonitorCsGraphTable`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    search: (param, callBack) => {
        param['limit'] = 5;
        GmxRequest.load(`${API_CONTEXT_API}/esupport/search/totalSearch`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    searchTotal: (param, callBack) => {
        //param['limit'] = 5;
        GmxRequest.load(`${API_CONTEXT_SEARCH_API}/_search`, { param, method: "POST" }, res => {
            callBack(res);
        });
    },

    selectNewPkey: async (param) => {
        let svc = param.svc == "CtOuts" ? "selectNewPkeyForOuts" : "selectNewPkey";
        return new Promise((resolve) => {

            GmxRequest.load(`${API_CONTEXT_API}/esupport/common/${svc}`, { param, method: "get" }, res => {
                resolve(JSON.parse(res.data.message).key);
            });

        });

    },

    selectCurrentPkey: (param) => {
        return new Promise((resolve) => {
            GmxRequest.load(`${API_CONTEXT_API}/esupport/common/selectCurrentPkey`, { param, method: "get" }, res => {
                resolve(JSON.parse(res.data.message).key);
            });

        });

    },

    addCommon: (code, param, callBack) => {

        const toDay = DateUtil.getYMDH24mmss();
        param['creDat'] = toDay;
        param['updDat'] = toDay;

        GmxRequest.load(`${getCodeUrl(code)}/insert${code}`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    updateCommon: (code, param, callBack) => {
        const toDay = DateUtil.getYMDH24mmss();
        param['updDat'] = toDay;
        GmxRequest.load(`${getCodeUrl(code)}/update${code}`, { param, method: "get" }, res => {
            
            callBack(res);
        });
    },

    updatePostCommon: (code, param, callBack) => {
        const toDay = DateUtil.getYMDH24mmss();
        param['updDat'] = toDay;
        GmxRequest.load(`${getCodeUrl(code)}/update${code}`, { param, method: "POST" }, res => {
            
            callBack(res);
        });
    },

    updateCommonNoValud: (code, param, callBack) => {
        const toDay = DateUtil.getYMDH24mmss();
        param['updDat'] = toDay;

        GmxRequest.load(`${getCodeUrl(code)}/update${code}NoValid`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    deleteCommon: (code, param, callBack) => {
        const toDay = DateUtil.getYMDH24mmss();
        param['updDat'] = toDay;
        GmxRequest.load(`${getCodeUrl(code)}/delete${code}`, { param, method: "get" }, res => {
            callBack(res);
        });
    },


    xlsData: (code, param, callBack) => {
        GmxRequest.load(`${getCodeUrl(code)}/selectExcelData`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    selectOrdersNtsKey: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/ctOrders/selectNtsKey`, { param, method: "get" }, res => {
            callBack(res);
        });
    },
    
    selectOutsNtsKey: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/ctOuts/selectNtsKey`, { param, method: "get" }, res => {
            callBack(res);
        });
    },
    
    sendMail : (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/common/sendMail`, { param, method: "get" }, res => {
            callBack(JSON.parse(res.data.message));
        });
    },
     //소속기관 정보를 리턴합니다.
     changeOrgMgrSeq: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/common/changeOrgMgrSeq`, { param, method: "post" }, res => {
            callBack(res);
        });
    },
    //메일 발송조건 내용을 리턴합니다.
    selectMailCon: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/mail/selectMailSendConItem`, { param, method: "post" }, res => {
            callBack(res);
        });
    },
    selectMailAuthList: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/mail/selectMailAuthList`, { param, method: "post" }, res => {
            callBack(res);
        });
    },
    //메일 발송 권한을 추가 합니다.
    insertMailAuthList: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/mail/insertMailAuthList`, { param, method: "post" }, res => {
            callBack(res);
        });
    },
    selectApproveList: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/approve/selectApproveAuthList`, { param, method: "post" }, res => {
            callBack(res);
        });
    },
    insertApproveList: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/approve/insertApproveAuthList`, { param, method: "post" }, res => {
            callBack(res);
        });
    },
    addAccessLog : (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/common/mtAccessLog/insertMtAccessLog`, { param, method: "post" }, res => {
            callBack(res);
        }); 
    },

     //세금계산서
     selectInvoiceList: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/barobill/tax/selectInvoiceList`, { param, method: "post" }, res => {
            callBack(res);
        });
    },

    //영업현황 - 수주 프로세스 승인권한자 조회
    selectSignList: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/ctSign/selectSignList`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    //영업현황 - 수주 프로세스 승인/반려
    updateConfirmSign: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/ctSign/confirmSign`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    updateReConfirmSign: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/ctSign/updateAllCtSign`, { param, method: "get" }, res => {
            callBack(res);
        });
    },    

    //승인 프로세스 시작
    startSignProcess: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/ctSign/startSignProcess`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

     //마지막 승인프로세스 찾기
    selectLastSignProcess: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/ctSignMaster/selectLastSignProcess`, { param, method: "get" }, res => {
            callBack(res);
        });
    }, 

    //signMaster 조회
    selectCtSignMasterList: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/ctSignMaster/selectSignMasterList`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    //지역조회
    selectMtRegionList: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/common/mtRegion/selectMtRegion`, { param, method: "get" }, res => {
            callBack(res);
        });
    }, 

    //솔루션현황 조회
    selectSolStateList: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/solstate/selectSolState`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    //전국 솔루션 납품 조회
    selectAllRegion: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/solstate/selectAllRegion`, { param, method: "get" }, res => {
            callBack(res);
        });
    },
    //지역별 솔루션 납품 조회회
    selectRegion: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/esupport/solstate/selectRegion`, { param, method: "get" }, res => {
            callBack(res);
        });
    },
    // === 알림 관련 API ===
    /**
     * 알림 생성/등록
     * @param {Object} param - 알림 생성 파라미터 (alarmNm, eventCont, alarmType, refKey, eventYn 등)
     * @param {Function} callBack - 콜백 함수
     */
    insertMtAlarmEvent: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/common/mtAlarmEvent/insertMtAlarmEvent`, { param, method: "post" }, res => {
            callBack(res);
        });
    },

    /**
     * 알림 목록 조회
     * @param {Object} param - 조회 파라미터 (userId, pageNo, pageSize 등)
     * @param {Function} callBack - 콜백 함수
     */
    selectMtAlarmEvent: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/common/mtAlarmEvent/selectMtAlarmEvent`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    /**
     * 읽지 않은 알림 개수 조회
     * @param {Object} param - 조회 파라미터 (userId)
     * @param {Function} callBack - 콜백 함수
     */
    selectMtAlarmEventUnreadCnt: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/common/mtAlarmEvent/selectMtAlarmEventUnreadCnt`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    /**
     * 사용자별 미확인 알림 조회
     * @param {Object} param - 조회 파라미터 (userId)
     * @param {Function} callBack - 콜백 함수
     */
    selectMtAlarmEventUnread: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/common/mtAlarmEvent/selectMtAlarmEventUnread`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    /**
     * 알림 읽음 처리
     * @param {Object} param - 파라미터 (alarmEventId, userId)
     * @param {Function} callBack - 콜백 함수
     */
    updateMtAlarmEventRead: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/common/mtAlarmEvent/updateMtAlarmEventRead`, { param, method: "post" }, res => {
            callBack(res);
        });
    },

    /**
     * 모든 알림 읽음 처리
     * @param {Object} param - 파라미터 (userId)
     * @param {Function} callBack - 콜백 함수
     */
    updateMtAlarmEventAllRead: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/common/mtAlarmEvent/updateMtAlarmEventAllRead`, { param, method: "post" }, res => {
            callBack(res);
        });
    },

    /**
     * 알림 삭제
     * @param {Object} param - 파라미터 (alarmEventId, userId)
     * @param {Function} callBack - 콜백 함수
     */
    deleteMtAlarmEvent: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/common/mtAlarmEvent/deleteMtAlarmEvent`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    /**
     * 읽은 알림 삭제
     * @param {Object} param - 파라미터 (userId)
     * @param {Function} callBack - 콜백 함수
     */
    deleteReadMtAlarmEvent: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/common/mtAlarmEvent/deleteReadMtAlarmEvent`, { param, method: "post" }, res => {
            callBack(res);
        });
    },

    /**
     * 모든 알림 삭제 (전체 삭제 API가 별도로 없다면 이 함수는 삭제하거나 수정 필요)
     * @param {Object} param - 파라미터 (userId)
     * @param {Function} callBack - 콜백 함수
     */
    deleteAllMtAlarmEvent: (param, callBack) => {
        // 전체 삭제 API가 없다면 개별 삭제로 처리하거나 백엔드에 추가 요청
        console.warn('전체 알림 삭제 API가 제공되지 않음. 개별 삭제로 처리 필요');
        callBack({
            data: {
                status: 'error',
                message: '전체 알림 삭제 기능이 구현되지 않았습니다.'
            }
        });
    },

    /**
     * 백업 파일 목록 조회
     * @param {Object} param - 조회 파라미터 (searchDate)
     * @param {Function} callBack - 콜백 함수
     */
    selectBackupFileList: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/common/backup/selectBackupFileList`, { param, method: "post" }, res => {
            callBack(res);
        });
    },

    /**
     * 수동 백업 실행
     * @param {Object} param - 파라미터 (빈 객체)
     * @param {Function} callBack - 콜백 함수
     */
    executeManualBackup: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/common/backup/executeManualBackup`, { param, method: "post" }, res => {
            callBack(res);
        });
    },


    
    /**
     * 백업 파일 다운로드 테스트
     * @param {Object} param - 파라미터 (fileName)
     * @param {Function} callBack - 콜백 함수
     */
    downloadBackupFileTest: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/common/backup/downloadBackupFileTest`, { param, method: "get" }, res => {
            callBack(res);
        });
    },

    /**
     * 백업 파일 다운로드 (POST 방식)
     * @param {Object} param - 파라미터 (fileName)
     * @param {Function} callBack - 콜백 함수
     */
    downloadBackupFile: (param, callBack) => {
        const url = `${API_CONTEXT_API}/backup/download`;
        
        axios({
            url: url,
            data: param,
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            responseType: "blob", // 바이너리 데이터로 응답 받기 위해 responseType을 'blob'으로 설정
        }).then((response) => {
            // 파일 다운로드를 위한 코드
            const contentDisposition = response.headers["content-disposition"];
            let filename = null;

            if (contentDisposition) {
                const matches = contentDisposition.match(/filename="(.+\..+)"/);
                if (matches && matches.length > 1) {
                    filename = matches[1];
                }
            }

            if (filename == null) {
                // .backup 파일은 .zip으로 다운로드
                filename = param.fileName.endsWith('.backup') ? 
                    param.fileName.replace('.backup', '.zip') : param.fileName;
            }

            filename = decodeURIComponent(filename);

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename); // 파일 이름과 확장자 지정
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            callBack(response);
        }).catch((error) => {
            console.error('다운로드 오류:', error);
            callBack(null);
        });
    },

    /**
     * 서버 상태 목록 조회
     * @param {Object} param - 조회 파라미터
     * @param {Function} callBack - 콜백 함수
     */
    selectServerStatusList: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/common/monitor/selectServerStatusList`, { param, method: "post" }, res => {
            callBack(res);
        });
    },

    /**
     * 개별 서버 상태 조회
     * @param {Object} param - 조회 파라미터 (serverId)
     * @param {Function} callBack - 콜백 함수
     */
    selectServerStatus: (param, callBack) => {
        GmxRequest.load(`${API_CONTEXT_API}/common/monitor/selectServerStatus`, { param, method: "post" }, res => {
            callBack(res);
        });
    },

   
};

